import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { useState } from "react";

interface AcceptNegotiationModalProps {
  onConfirm: () => void;
  isLoading?: boolean;
}

const AcceptNegotiationModal = ({ onConfirm, isLoading }: AcceptNegotiationModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button>
            Aceitar negociação
          </Button>
        )}
        body={(
          <div className="flex flex-col gap-4">
            <p className="text-white-800 text-2xl">Aceitar negociação</p>

            <div className="flex flex-col text-white-400">
              <p>Você tem certeza que deseja aceitar essa negociação?</p>
            </div>
          </div>
        )}
        useCancellableFooter
        cancelButtonText="Voltar"
        confirmButtonText="Aceitar"
        cancelButtonClassName="bg-black-600"
        confirmButtonClassName="bg-primary-blue"
        className="rounded-lg overflow-hidden bg-black-900"
        onConfirm={onConfirm}
        confirmButtonIsLoading={isLoading}
      />
    </>
  );
};

export default AcceptNegotiationModal;
